<template>
  <div :id="'cont_' + formProperty.nativename" :class="getCompCSS(volatile)">
    <!-- :accept="formProperty.allowedFileTypes ? formProperty.allowedFileTypes : 'image/*'" -->
    <!-- :capture="formProperty.dataTypeID == StaticData.DATATYPES.TYPE_PHOTO?'camera':null" -->

    <!-- :hint="getHint()" -->
    <div :class="formProperty.cssClass + (formProperty.readonly || readOnly ? ' disabled' : '')">
      <!--      {{ mydebugAccept }} - {{ mydebugCapture }}-->
      <q-uploader :auto-expand="true" :class="(formProperty.invalid?' uplError':'')" :clearable="!(formProperty.readonly || readOnly)" :disable="formProperty.readonly || readOnly" :filled="true"
                  :form-fields="additionalFields" :id="formProperty.nativename" :label="getTitle()" :multiple="false" :placeholder="formProperty.infoTextHint"
                  :readonly="formProperty.readonly || readOnly" :ref="formProperty.nativename" @added="addFile" @removed="removeFile" @uploaded="uploadDone"
                  class="full-width" color="grey-3" field-name="file" flat environment="can"
                  :accept="getAcceptedMedia()" :capture="getCaptureMedia()"
                  :max-file-size="formProperty.filesizeMax ? formProperty.filesizeMax * 1024 : 1024*1024*5"
                  @rejected="rejectFile" hide-hint url="/i1-mobileproxy/service/rest/fileupload"
      >
        <template #header="scope">
          <div class="row no-wrap frmUpload" :style="(volatile || compressed) ? 'height: 40px; padding: 5px;':''">
            <q-btn @click="scope.removeUploadedFiles" dense flat icon="done_all" round v-if="scope.uploadedFiles.length > 0">
              <q-tooltip>Datei entfernen</q-tooltip>
            </q-btn>

            <q-spinner class="q-uploader__spinner" v-if="scope.isUploading"/>

            <div class="col">
              <div class="q-uploader__title">{{ formProperty.title }}</div>
              <div class="q-uploader__subtitle">{{ scope.uploadSizeLabel }} / {{ scope.uploadProgressLabel }}</div>
            </div>

            <q-btn dense flat icon="add_box" round v-if="!(formProperty.readonly || readOnly) && (value==='' || value==null) && existingFilename == null">
              <q-uploader-add-trigger/>
              <q-tooltip>Datei zum Upload auswählen</q-tooltip>
            </q-btn>

            <q-btn dense flat icon="photo_camera" round v-if="$q.platform.is.win && (!(formProperty.readonly || readOnly) && (value==='' || value==null) && existingFilename == null)" @click="showPhotoDlg = true">
              <q-tooltip>Foto aufnehmen</q-tooltip>
            </q-btn>

            <q-btn @click="scope.abort" dense flat icon="clear" round v-if="!(formProperty.readonly || readOnly) && scope.isUploading">
              <q-tooltip>Upload abbrechen</q-tooltip>
            </q-btn>
          </div>
        </template>

        <template #list="scope">
          <q-list separator>
            <q-item :key="file.name" v-for="file in scope.files">
              <q-item-section>
                <q-item-label class="full-width ellipsis">
                  {{ file.name }}
                </q-item-label>
              </q-item-section>

              <q-item-section thumbnail v-if="file.__img">
                <img :src="file.__img.src">
              </q-item-section>

              <q-item-section side top>
                <q-btn @click="scope.removeFile(file)" dense flat icon="delete" round size="12px"/>
              </q-item-section>
            </q-item>
          </q-list>
        </template>
      </q-uploader>
    </div>

    <span v-if="existingFilename" style="display: inline-block; width: 100%; text-align:right">
        <a href="#" @click.prevent="dwldFile">{{ getDisplayFilename(existingFilename) }} </a>
        <q-btn v-if="!(formProperty.readonly || readOnly)" @click="existingFilename=null;value=null;removeFile();" dense flat icon="delete" round size="12px"/>
    </span>

    <div class="errMsg" v-if="formProperty.invalid">{{ getErrorLabel() }}</div>
    <div v-else style="height:20px"></div>


    <q-dialog v-model="showPhotoDlg" class="photoDlg" persistent>
      <q-card>
        <q-card-section style="padding: 4px">
          <div class="row items-center">
            <div class="text-h6">Foto aufnehmen</div>
            <q-space/>
            <q-btn icon="close" flat round dense v-close-popup/>
          </div>
        </q-card-section>

        <q-card-section style="padding: 4px">
          <photo-comp :filename="getFileName()" @photoTaken="onPhotoTaken" @photoError="onPhotoError" v-if="showPhotoDlg"/>
        </q-card-section>

        <q-card-actions align="right" style="padding: 4px">
          <q-btn color="primary" flat label="Foto speichern" @click="clickPhoto"/>
          <q-btn label="Abbrechen" color="grey" flat @click="showPhotoDlg=false"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import Compressor from 'compressorjs';
import {getValueOrCleanNull} from './formsHelper'

import useVuelidate from '@vuelidate/core'
import {requiredIf} from '@vuelidate/validators'
import {fldComponentsMixin} from './mixins/fldComponent'
import {StaticData} from '../../classes/StaticData'
import {setCssVar} from 'quasar'
import PhotoComp from '../tech/photo-comp'
import {useAuthStore} from 'src/stores/AuthStore.js'
import FileHelper from "../../classes/FileHelper";
import {useQueryStore} from "stores/QueryStore.js";
import download from "downloadjs";
import URLHelper from "src/classes/URLHelper.js";

export default {
  mixins: [fldComponentsMixin],
  props: [
    'queryID',
    'formProperty',
    'volatile',
    'compressed',
    'readOnly'
  ],
  components: {
    PhotoComp
  },
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      StaticData,
      value: this.formProperty.value,
      uploadedFiles: [],
      errorMsg: "",
      additionalFields: [],
      headers: [],
      fnResolve: null,
      existingFilename: null,
      existingFilecontentBase64: null,
      showPhotoDlg: false,
      compressing: false,
      doFileUpload: false,
      mydebugCapture: "",
      mydebugAccept: ""
    }
  },
  validations() {
    return this.getValidations()
  },
  watch: {
    value: function () {
      this.formProperty.value = getValueOrCleanNull(this.value, this.formProperty)
    },
    formProperty: {
      handler: function (newVal) {
        this.value = newVal.value
      },
      deep: false
    }
  },
  methods: {
    getAcceptedMedia() {
      let result = this.formatFileExtensions(this.formProperty.allowedFileTypes)

      if (this.formProperty.dataTypeID === StaticData.DATATYPES.TYPE_FILE) {
        /*
                if (this.formProperty.allowedFileTypes) {
                  result += this.formProperty.allowedFileTypes + ","
                }
        */
        if (this.$q.platform.is.mobile) result += "text/plain"

      } else if (this.formProperty.dataTypeID === StaticData.DATATYPES.TYPE_PHOTO) {
        if (this.formProperty.fileAllowPickFromGallery &&
          this.formProperty.fileAllowPickFromCam) {
          if (this.$q.platform.is.mobile) result += "text/plain"
        }
        if (this.formProperty.fileAllowPickFromGallery) result += ",image/*,video/*"
      }

      if (this.$q.platform.is.mobile && this.$q.platform.is.firefox) result += ",image/*,video/*"

      this.mydebugAccept = result
      return result
    },
    formatFileExtensions(input) {
      let result = ""
      if (input) {
        const extensions = input.replace(/\s+/g, '').split(',')
        const formattedExtensions = extensions.map(ext => ext.startsWith('.') ? ext : `.${ext}`)
        result = formattedExtensions.join(',') + ","
      }
      return result
    },

    getCaptureMedia() {
      let result = null
      if (this.formProperty.fileAllowPickFromCam && !this.formProperty.fileAllowPickFromGallery) {
        result = "camera"
      }
      this.mydebugCapture = result
      return result
    },

    async dwldFile() {
      if (this.value && this.value.toLowerCase().startsWith("file://")) {
        try {
          const queryStore = useQueryStore()
          this.$q.loading.show()
          let response = await queryStore.downloadFile(this.value)

          if (response && response.filename && response.data) {
            if (response.filename.toLowerCase().endsWith(".pdf")) {
              // open integrated PDF viewer
              this.eventBus.printPreview(response.data, response.filename)

            } else {
              // download with download.js
              download(response.data, response.filename)
            }
          } else {
            this.eventBus.globalErrorHandling(this.$t('fileDownloadErrorNoSQLResult'))
          }

        } catch (error) {
          this.eventBus.globalErrorHandling(this.$t('fileDownloadError'), error)

        } finally {
          this.$q.loading.hide()
        }

      } else if (this.formProperty.propertyInstanceID) {
        // file has instanceID - so load it as blob in printPreview.vue with queryStore.documentGetAsBase64
        printPreviewWithPropID(this.formProperty.propertyInstanceID)

      } else if (this.existingFilecontentBase64) {
        switch (FileHelper.getFileExtension(this.existingFilename)) {
          case "jpg":
          case "jpeg":
          case "png":
          case "gif":
          case "svg":
          case "pdf":
            printPreviewWithBase64(this.existingFilename, this.existingFilecontentBase64)
            break
          default:
            this.download(this.existingFilecontentBase64)
        }
      }
    },

    download(filecontentBase64) {
      const link = document.createElement('a')
      link.target = "_blank"
      link.href = filecontentBase64
      link.setAttribute('download', this.filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
    },

    onChange(value) {
      this.v$.value.$touch
      this.value = value
      this.formProperty.value = value
      this.setErrorBrandColor()
      console.log("fldFile: onChange. value=", value)
      //this.$emit('onChange', { classID: this.formProperty.classID, deleteDependentFields:true})  // send onChange event to parent (formular or parameter)
    }
    ,
    getValidations() {
      let result = {value: {}}
      //console.log("!!!!validate")
      if (!this.formProperty.lengthMin) this.formProperty.lengthMin = 0
      result.value['requiredIf'] = requiredIf(() => {
        if (this.formProperty.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
          return (this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY) && this.formProperty.showThroughDependency === true
        } else {
          return this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY
        }
      })
      result.value['isValidGen'] = () => {  // generell invalid flag (triggered from extern)
        //console.log("invalid from property: ", this.formProperty.title,"=",this.formProperty.invalid)
        if (!this.formProperty.invalid) return true;
        return !this.formProperty.invalid
      }
      return result
    }
    ,
    getErrorLabel() {
      let result = ""
      /*
      if (!this.v$.value.minLength || !this.v$.value.requiredIf) {
        result = "Ungültige Länge, min: " + this.v$.value.$params.minLength.min

      } else if (!this.v$.value.maxLength) {
        result = "Ungültige Länge, max: " + this.v$.value.$params.maxLength.max

      } else { // if (!this.v$.value.isValidGen) {
        result = this.errorMsg
      }
    */
      result = this.errorMsg
      return result
    }
    ,

    addFile(file) {
      this.formProperty.invalid = false
      this.value = file[0].name
      this.errorMsg = ""

      if (this.$route.name === StaticData.ROUTE_NAMES.FORMULAR) {
        this.eventBus.formularEdited()
      }

      // compress only bitmap images jpg and png
      if (file[0].name.indexOf(".jpg") !== -1 ||
        file[0].name.indexOf(".jpeg") !== -1 ||
        file[0].name.indexOf(".png") !== -1) {

        if (!this.compressing && this.formProperty.imageCompressionlevel > 0) {
          this.compressFile(file[0])
        }
      }
      this.doFileUpload = true
    }
    ,

    compressFile(file) {
      if (this.compressing) {
        return
      }
      const nativename = this.formProperty.nativename
      const uploader = this.$refs[nativename]
      new Compressor(file, {
        quality: this.formProperty.imageCompressionlevel / 10,
        maxWidth: this.formProperty.imageMaxwidth == 0 ? null : this.formProperty.imageMaxwidth,
        maxHeight: this.formProperty.imageMaxheight == 0 ? null : this.formProperty.imageMaxheight,
        success: (compressedFile) => {
          this.compressing = true
          const newFile = new File([compressedFile], file.name, {type: file.type})
          uploader.removeFile(file)
          uploader.addFiles([newFile])
          this.compressing = false
        },
        error: (err) => {
          console.error('Image compression error:', err);
        },
      });
    }
    ,

    removeFile(file) {
      if (this.compressing) {
        return
      }
      this.formProperty.defaultValue = null
      this.formProperty.invalid = false
      this.value = ""
      this.formProperty.value = null
      this.errorMsg = ""
      if (this.$route.name === StaticData.ROUTE_NAMES.FORMULAR) {
        this.eventBus.formularEdited()
      }
    }
    ,
    rejectFile(file) {
      if (file[0]) {
        let failObj = file[0]
        if (failObj.failedPropValidation === 'accept') {
          let allowedTypes = this.formProperty.allowedFileTypes ? this.formProperty.allowedFileTypes : 'Bilddateien'
          this.errorMsg = this.formProperty.fileLabelTypes ? this.formProperty.fileLabelTypes : 'Nicht unterstütztes Dateiformat. Gültige Formate sind: ' + allowedTypes
        } else if (failObj.failedPropValidation === 'max-file-size') {
          if (this.formProperty.filesizeMax) {
            this.errorMsg = this.formProperty.fileLabelSize ? this.formProperty.fileLabelSize : 'Die Dateigröße übersteigt die maximale Dateigröße von ' + this.formProperty.filesizeMax + ' KB.'
          } else {
            this.errorMsg = this.formProperty.fileLabelSize ? this.formProperty.fileLabelSize : 'Die Dateigröße übersteigt die maximale Dateigröße von 5 MB.'
          }
        }
        this.formProperty.invalid = true
        this.v$.$touch()
      }
    }
    ,
    startUpload(data) {
      const authStore = useAuthStore()
      if (this.formProperty.classID === data.classID && (data.subtypeCount === undefined || data.subtypeCount === this.formProperty.subtypeCount) && (data.possibleSubclassCounter === undefined || data.possibleSubclassCounter === this.formProperty.possibleSubclassCounter)) {
        if (this.doFileUpload) {
          console.log("....fldFile: UPLOAD!", this.value, ", ", this.formProperty.title, ", ", data)
          this.additionalFields.push({'name': 'classID', 'value': data.classID})
          this.additionalFields.push({'name': 'userLoginname', 'value': authStore.loginname})
          this.headers.push({'name': 'Content-Type', 'value': ''});
          this.fnResolve = data.fnResolve
          //this.$refs.cmpUpload.upload()
          eval("this.$refs." + this.formProperty.nativename + ".upload()")
          this.doFileUpload = false
        } else {
          console.log("fldFile - resolve:", this.formProperty.title)
          data.fnResolve()
        }
      }
    }
    ,
    uploadDone(file, xhr) {
      //console.log(file, xhr)
      //this.value = xhr.responseText
      //console.log("...uploadDone. xhr: ", xhr)
      this.fnResolve()
      //console.warn("called resolve - ", this.fnResolve)
    }
    ,
    onPhotoTaken(photo) {
      // add file manually
      let array = []
      array[0] = photo
      this.$refs[this.formProperty.nativename].addFiles(array)
      this.showPhotoDlg = false
    }
    ,
    onPhotoError(error) {
      this.showPhotoDlg = false
      this.formProperty.errorMsg = this.getCameraInitErrorMsg(error)
      this.formProperty.invalid = true
    }
    ,
    clickPhoto() {
      this.eventBus.doPhoto()
    }
    ,
    getCameraInitErrorMsg(error) {
      let result = ""
      if (error.name === 'NotAllowedError') {
        result = "Fehler: Kamerazugriff wurde nicht erlaubt"
      } else if (error.name === 'NotFoundError') {
        result = "Fehler: keine Kamera verfügbar"
      } else if (error.name === 'NotSupportedError') {
        result = "Fehler: HTTPS benötigt"
      } else if (error.name === 'NotReadableError') {
        result = "Fehler: wird die Kamera bereits verwendet?"
      } else if (error.name === 'OverconstrainedError') {
        result = "Fehler: Kamera kann nicht benutzt werden"
      } else if (error.name === 'StreamApiNotSupportedError') {
        result = "Fehler: Stream API wird von diesem Bowser nicht unterstützt"
      }
      return result
    }
    ,

    setErrorBrandColor() {
      try {
        if (this.formProperty.requiredMode == StaticData.FORM_REQUIRED_MODES.LAZY) {
          setCssVar('negative', '#f57c00', document.getElementById('cont_' + this.formProperty.nativename))
        } else {
          setCssVar('negative', '#c10015', document.getElementById('cont_' + this.formProperty.nativename))
        }
      } catch (e) {
      }
    }
    ,

    getFileName() {
      let filename = this.formProperty.nativename
      if (this.formProperty.possibleSubclassCounter !== undefined && this.formProperty.possibleSubclassCounter !== null) {
        filename += this.formProperty.possibleSubclassCounter
      }
      if (this.formProperty.subtypeCount !== undefined && this.formProperty.subtypeCount !== null) {
        filename += this.formProperty.subtypeCount
      }
      return filename
    },

    getDisplayFilename(filename) {
      let result = URLHelper.getParamValue(filename, "fldLblFrmFld")
      if (!result) result = filename
      return result
    },

    parseFilenameFromDefaultValue(defaultValue) {
      try {
        const defaultValueJSON = JSON.parse(defaultValue);
        this.existingFilename = defaultValueJSON.filename
        this.existingFilecontentBase64 = defaultValueJSON.file
      } catch (e) {
        this.existingFilename = defaultValue
      }
      // console.log("parseFilenameFromDefaultValue: ", this.formProperty.title, ": ", this.existingFilename)
    }
  },

  beforeUnmount() {
    //console.log("fldFile - destroy " + this.formProperty.title)
    this.eventBus.off('onUploadFileFormField', this.startUpload)
  }
  ,

  mounted: function () {
    if (this.formProperty.defaultValue) {
      this.formProperty.invalid = false
      this.errorMsg = ""
      this.parseFilenameFromDefaultValue(this.formProperty.defaultValue)

      // will skip updating this field with an empty value if left unchanged
      this.value = this.value ? this.value : this.formProperty.propertyInstanceValue // native value
      this.formProperty.value = this.value
    }

    this.formProperty.validate = () => {
      //console.log("validate in mounted. value is", this.value)
      let required = false
      this.formProperty.invalid = false
      if (this.formProperty.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
        required = (this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) && this.formProperty.showThroughDependency === true
      } else {
        required = this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY
      }
      if (required) {
        if ((!this.value || this.value == null) && (!this.formProperty.defaultValue || this.formProperty.defaultValue == null)) {
          this.formProperty.invalid = true
          this.errorMsg = this.formProperty.infoRequired && this.formProperty.infoRequired !== "" ? this.formProperty.infoRequired : "Bitte Datei/Bild zum Upload auswählen."
          this.formProperty.setError(this.errorMsg)
          this.setErrorBrandColor()
        }
      }
      //console.log("validate fldFile! invalidate:", this.formProperty.invalid )
    }

    this.formProperty.setValid = () => {
      this.formProperty.errorMsg = ""
      this.formProperty.invalid = false
      this.v$.$touch()
    }

    this.formProperty.setError = (errMsg) => {
      let tmp = this.value;
      this.value = "";
      this.value = tmp // rerender field & errorstats
      this.formProperty.errorMsg = errMsg
      this.formProperty.invalid = true
      this.v$.$touch()
    }

    this.eventBus.on('onUploadFileFormField', this.startUpload)

    //let uploadPlusIcon = document.querySelector("." + this.cssClass + " .q-icon")
    //uploadPlusIcon.firstChild.textContent = "file_upload"
  }

}
</script>

<style lang="sass">
.q-uploader
  //padding 4px 0 0 0

  .q-field-label
    font-weight: bold

  .q-uploader .q-input-target
    font-size: 10px
    margin-right: 5px
    color: #aaa

  .q-uploader__title,
  .q-uploader__subtitle,
  .q-btn__content
    color: rgba(0, 0, 0, 0.6)

  .q-uploader__list
    min-height: 0
    padding: 0

    .q-uploader__title,
    .q-uploader__subtitle,
    .q-btn__content
      color: white

  .q-item__section--side .q-icon
    color: rgba(0, 0, 0, 0.6)

.errMsg
  color: $negative
  font-size: 12px
  margin: -4px 0 0 11px !important
  line-height: 28px

.uplError .row:first-child
  border-bottom: 2px solid $negative

.frmUpload
  padding: 10px

//.q-field--dense .q-field__label
//  top: 6px

.photoDlg
  height: 50%
</style>
